import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TiposDocumentalesService {
  private apiUrl = `${environment.apiUrl}/api/tipos-documentales`;

  constructor(private http: HttpClient) { }

  getAllTipos(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl);
  }

  getTipoById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

  createTipo(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, data);
  }

  updateTipo(id: number, data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, data);
  }

  deleteTipo(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }
}